import { apiAuthClient } from 'api/helpers';
import { stringifyUrlQuery } from 'helpers';

import type {
  GetBoardFormsResponseType,
  GetBoardFormsRequestType,
} from '../types';

export const getBoardForms = async ({
  pathParams: { organisationId, boardId },
  queryParams: { id, name, page, updatedFrom, updatedTo, sortDir },
}: GetBoardFormsRequestType): Promise<GetBoardFormsResponseType> => {
  const sortParams = sortDir ? { sortBy: 'updated_at', sortDir } : undefined;
  const query = stringifyUrlQuery({
    id,
    name,
    page,
    updatedFrom,
    updatedTo,
    ...sortParams,
  });

  const url = `/api/v2/organisations/${organisationId}/boards/${boardId}/forms${query}`;
  const { data } = await apiAuthClient.get<GetBoardFormsResponseType>(url);

  return data;
};
